import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type MonthOption = {
  value: number;
  label: string;
};

export function useMonths() {
  const { t } = useTranslation();

  const monthOptions: MonthOption[] = [
    { label: t("month-january"), value: 1 },
    { label: t("month-february"), value: 2 },
    { label: t("month-march"), value: 3 },
    { label: t("month-april"), value: 4 },
    { label: t("month-may"), value: 5 },
    { label: t("month-june"), value: 6 },
    { label: t("month-july"), value: 7 },
    { label: t("month-august"), value: 8 },
    { label: t("month-september"), value: 9 },
    { label: t("month-october"), value: 10 },
    { label: t("month-november"), value: 11 },
    { label: t("month-december"), value: 12 },
  ];

  const months: string[] = [
    t("month-january"),
    t("month-february"),
    t("month-march"),
    t("month-april"),
    t("month-may"),
    t("month-june"),
    t("month-july"),
    t("month-august"),
    t("month-september"),
    t("month-october"),
    t("month-november"),
    t("month-december"),
  ];

  return { months, monthOptions };
}
